import makeStyles from '@mui/styles/makeStyles';
import { grey, isDark } from 'global/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    margin: '0 auto',
    maxWidth: 1200,
    padding: theme.spacing(2),
    border: `1px solid black`,

    '& a': {
      color: theme.colors.blue
    }
  },
  tierBox: {
    margin: `${theme.spacing(3)} 0`
  }
}));
